module.exports = __webpack_public_path__ + "static/media/mahnush.550d5a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/mahnush.png
// module id = 287
// module chunks = 0